export default {
  MUNICIPIOS: {
    parametroQuery: 'nome',
    tituloX: 'Municípios'
  },
  SETOR: {
    parametroQuery: 'setor',
    tituloX: 'Setor'
  },
  SITUACAO: {
    parametroQuery: 'status',
    tituloX: 'Situação'
  },
  PERIODO: {
    parametroQuery: 'data_cadastro',
    tituloX: {
      day: 'Data de cadastro',
      month: 'Mês de cadastro',
      year: 'Ano de cadastro'
    }
  },
  TIPO: {
    QUANTIDADE: {
      tituloY: 'Quantidade de processos',
      switchValue: false,
      tipoQuery: 'count'
    },
    AREA: {
      tituloY: 'Total de área (em ha)',
      switchValue: true,
      tipoQuery: 'sum'
    }
  },
  DEFAULT: {
    tipoQuery: 'count',
    parametroQuery: 'nome',
    tituloX: 'Municípios',
    tituloY: 'Quantidade de processos',
    switchValue: false,
    abaAtiva: 'MUNICIPIOS',
    showGrafico: true
  },
  TIPO_DATA: {
    diario: 'day',
    mensal: 'month',
    anual: 'year'
  },
  FILTRO_EMPTY: {
    status: 'TODOS',
    setor: null,
    municipio: null,
    perfil: null,
    periodo: null,
    numeroProcesso: null,
    pagina: 0,
    tamanhoPagina: 15,
    simplificado: false,
    municipios: [],
    withStatus: [],
    ordem: null,
    ordemDirecao: null
  },
  SETORES: {
    TODOS: ['GAT', 'CAF', 'CPAT', 'GP', 'GDA'],
    GERENTE: ['GAT', 'GDA'],
    ANALISTA: ['GAT'],
    COORDENADOR: ['CAF'],
    PRESIDENTE: ['CPAT', 'GP'],
    ADM_S1: ['GP']
  },
  PERFIS: [
    {
      codigo: 'GERENTE',
      nome: 'Gerente'
    },
    {
      codigo: 'ANALISTA',
      nome: 'Analista'
    },
    {
      codigo: 'COORDENADOR',
      nome: 'Coordenador'
    },
    {
      codigo: 'PRESIDENTE',
      nome: 'Presidente'
    },
    {
      codigo: 'ADM_S1',
      nome: 'Administrativo S2'
    }
  ],
  STATUS: [
    {
      id: 'FINALIZADO',
      nome: 'Processos de arrecadação concluídos'
    },
    {
      id: 'EM_ANDAMENTO',
      nome: 'Processos em arrecadação'
    },
    {
      id: 'TODOS',
      nome: 'Todos'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/screens/arrecadacao/relatorios/constants/tipoParametros.js